import { render, staticRenderFns } from "./APIPolicies.vue?vue&type=template&id=79a0fc67&scoped=true"
import script from "./APIPolicies.vue?vue&type=script&lang=js"
export * from "./APIPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0fc67",
  null
  
)

export default component.exports